import React, { useMemo } from 'react';
import { useTranslation } from '../../../config/Translations';
import { isListingMonetizationAEnabled } from '@b/helpers/ABTesting';
import { DELIVERY_TYPE_EMAIL, DELIVERY_TYPE_MOBILE } from '../reducers/delivery';

const descriptionOverrides = {
  [DELIVERY_TYPE_EMAIL]: 'checkout__ticket_will_be_sent',
  [DELIVERY_TYPE_MOBILE]: 'checkout__tickets_sent_to_your_phone',
}

export const DeliveryDescription = (props) => {
  const { deliveryOption, isKioskMode } = props;

  const { t } = useTranslation();

  const deliveryDescription = useMemo(() => {
    const description = deliveryOption.description?.trim();

    if (!description && !isListingMonetizationAEnabled()) {
      return;
    }

    if (isListingMonetizationAEnabled() && !description && descriptionOverrides[deliveryOption.method_type]) {
      return t(descriptionOverrides[deliveryOption.method_type]);
    }

    if (!description) {
      return;
    }

    if (description.startsWith('checkout__')) {
      return t(description);
    }

    return description;
  }, [deliveryOption, t]);

  if (isKioskMode) {
    return null;
  }

  return <div className="input__caption">{deliveryDescription}</div>;
};
